import React from 'react';
import { Tag } from '@onward-delivery/design';

/**
 * An onboarding badge: a design-system Tag with a solid dot in the badge's colour before the label. Used on the cards
 * and in both dialogs so a badge looks the same everywhere.
 *
 * @param {{ variant: string, children: React.ReactNode }} props
 */
const BadgeTag = ({ variant, children }) => (
    <Tag variant={variant} className="whitespace-nowrap text-[11px] font-semibold">
        <span className="size-1.5 shrink-0 rounded-full bg-current" aria-hidden="true" />
        {children}
    </Tag>
);

export default BadgeTag;
